import script from "./AddBehaviorOccurrenceButton.vue?vue&type=script&setup=true&lang=js"
export * from "./AddBehaviorOccurrenceButton.vue?vue&type=script&setup=true&lang=js"

import "./AddBehaviorOccurrenceButton.vue?vue&type=style&index=0&id=1962aa16&lang=css"

const __exports__ = script;

export default __exports__
import QList from 'quasar/src/components/item/QList.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QList});
